import { NavLink, useNavigate } from "react-router-dom";
import { Home, TrendingUp, Clock, User, Camera } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/progress", icon: TrendingUp, label: "Progress", testid: "nav-progress" },
  { to: "/history", icon: Clock, label: "History", testid: "nav-history" },
  { to: "/profile", icon: User, label: "Profile", testid: "nav-profile" },
];

export function BottomNav() {
  const navigate = useNavigate();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none">
      <div className="max-w-md mx-auto px-4 pb-4">
        <div className="relative">
          <button
            onClick={() => navigate("/scan")}
            data-testid="nav-scan"
            aria-label="Scan food"
            className="pointer-events-auto absolute left-1/2 -translate-x-1/2 -top-7 w-16 h-16 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 flex items-center justify-center active:scale-95 hover:bg-primary/90 transition-transform"
          >
            <Camera className="w-7 h-7" strokeWidth={2.2} />
          </button>
          <nav className="pointer-events-auto flex items-center justify-between rounded-full border border-white/50 bg-white/70 backdrop-blur-xl px-5 py-3 shadow-lg shadow-black/5">
            {items.slice(0, 2).map((it) => (
              <NavItem key={it.to} {...it} />
            ))}
            <div className="w-16" />
            {items.slice(2).map((it) => (
              <NavItem key={it.to} {...it} />
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}

function NavItem({ to, icon: Icon, label, testid }) {
  return (
    <NavLink
      to={to}
      data-testid={testid}
      className={({ isActive }) =>
        `flex flex-col items-center gap-0.5 w-12 transition-colors ${
          isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
        }`
      }
    >
      <Icon className="w-5 h-5" strokeWidth={2.2} />
      <span className="text-[10px] font-semibold">{label}</span>
    </NavLink>
  );
}
